import React, { useEffect } from "react";
import {
  ORGANIZATION_ID,
  buildInstantDownloadShippingDetails,
  buildReturnPolicyReference,
} from "./../../components/SchemaHelpers.js";

const ProductReviewSchemaMarkup = ({ productData, reviews, averageRating }) => {
  useEffect(() => {
    if (!productData) return;

    const productUrl = `https://parishaudio.com/products/${productData.productURI}`;
    const pageId = `${productUrl}#webpage`;

    const imageUrls = [
      productData.googleMarketplaceImage
        ? `https://parishaudio.com${productData.googleMarketplaceImage}`
        : null,
      ...(productData.images || [])
        .filter((img) => img && img.URI)
        .map((img) => `https://parishaudio.com${img.URI}`),
    ].filter(Boolean);

    const uniqueImageUrls = [...new Set(imageUrls)];

    const productId = `${productUrl}#product`;
    const offerId = `${productUrl}#offer`;

    const visibleReviews = (reviews || []).filter(
      (review) => review && review.visible !== false
    );

    const schemaData = [
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": pageId,
        url: productUrl,
        name: `${productData.name} | Parish Audio`,
        description:
          productData.longDescription ||
          productData.shortDescription ||
          productData.cardSummary ||
          undefined,
      },
      {
        "@context": "https://schema.org",
        "@type": "Product",
        "@id": productId,
        name: productData.name,
        description:
          productData.longDescription ||
          productData.shortDescription ||
          productData.cardSummary ||
          undefined,
        sku: productData.SKU || undefined,
        url: productUrl,
        image: uniqueImageUrls.length > 0 ? uniqueImageUrls : undefined,
        brand: {
          "@type": "Brand",
          name: "Parish Audio",
        },
        manufacturer: {
          "@type": "Organization",
          "@id": ORGANIZATION_ID,
          name: "Parish Audio",
          url: "https://parishaudio.com",
        },
        mainEntityOfPage: {
          "@id": pageId,
        },
        offers: {
          "@type": "Offer",
          "@id": offerId,
          url: productUrl,
          price: Number(productData.price || 0).toFixed(2),
          priceCurrency: "USD",
          availability: "https://schema.org/InStock",
          itemCondition: "https://schema.org/NewCondition",
          seller: {
            "@type": "Organization",
            "@id": ORGANIZATION_ID,
            name: "Parish Audio",
            url: "https://parishaudio.com",
          },
          hasMerchantReturnPolicy: buildReturnPolicyReference(),
          shippingDetails: buildInstantDownloadShippingDetails("USD"),
        },
        aggregateRating:
          visibleReviews.length > 0
            ? {
                "@type": "AggregateRating",
                ratingValue: Number(averageRating || productData.starRating || 0),
                reviewCount: Number(
                  productData.ratingCount || visibleReviews.length
                ),
                bestRating: 5,
                worstRating: 1,
              }
            : undefined,
            review:
            visibleReviews.length > 0
              ? visibleReviews.slice(0, 10).map((review, index) => ({
                  "@type": "Review",
                  "@id": `${productUrl}#review-${review._id || index}`,
                  name: review.title?.trim() || undefined,
                  author: {
                    "@type": "Person",
                    name: review.userName || "Anonymous",
                  },
                  datePublished: review.createdAt,
                  dateModified: review.updatedAt || review.createdAt,
                  reviewBody: review.comment || undefined,
                  reviewRating: {
                    "@type": "Rating",
                    ratingValue: Number(review.starRating),
                    bestRating: 5,
                    worstRating: 1,
                  },
                }))
              : undefined,

      },
    ];

    const cleanedSchemaData = JSON.parse(JSON.stringify(schemaData));

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(cleanedSchemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [productData, reviews, averageRating]);

  return null;
};

export default ProductReviewSchemaMarkup;

// import React, { useEffect } from "react";
// import {
//   ORGANIZATION_ID,
//   buildInstantDownloadShippingDetails,
//   buildReturnPolicyReference,
// } from "./../../components/SchemaHelpers.js";

// const ProductReviewSchemaMarkup = ({ productData, reviews, averageRating }) => {
//   useEffect(() => {
//     if (!productData) return;

//     const productUrl = `https://parishaudio.com/products/${productData.productURI}`;
//     const pageId = `${productUrl}#webpage`;

//     const imageUrls = [
//       productData.googleMarketplaceImage
//         ? `https://parishaudio.com${productData.googleMarketplaceImage}`
//         : null,
//       ...(productData.images || [])
//         .filter((img) => img && img.URI)
//         .map((img) => `https://parishaudio.com${img.URI}`),
//     ].filter(Boolean);

//     const uniqueImageUrls = [...new Set(imageUrls)];

//     const productId = `${productUrl}#product`;
//     const offerId = `${productUrl}#offer`;

//     const visibleReviews = (reviews || []).filter(
//       (review) => review && review.visible !== false
//     );

//     const schemaData = [
//       {
//         "@context": "https://schema.org",
//         "@type": "WebPage",
//         "@id": pageId,
//         url: productUrl,
//         name: `${productData.name} | Parish Audio`,
//         description:
//           productData.longDescription ||
//           productData.shortDescription ||
//           productData.cardSummary ||
//           undefined,
//       },
//       {
//         "@context": "https://schema.org",
//         "@type": "Product",
//         "@id": productId,
//         name: productData.name,
//         description:
//           productData.longDescription ||
//           productData.shortDescription ||
//           productData.cardSummary ||
//           undefined,
//         sku: productData.SKU || undefined,
//         url: productUrl,
//         image: uniqueImageUrls.length > 0 ? uniqueImageUrls : undefined,
//         brand: {
//           "@type": "Brand",
//           name: "Parish Audio",
//         },
//         manufacturer: {
//           "@type": "Organization",
//           "@id": ORGANIZATION_ID,
//           name: "Parish Audio",
//           url: "https://parishaudio.com",
//         },
//         mainEntityOfPage: {
//           "@id": pageId,
//         },
//         offers: {
//           "@type": "Offer",
//           "@id": offerId,
//           url: productUrl,
//           price: Number(productData.price || 0).toFixed(2),
//           priceCurrency: "USD",
//           availability: "https://schema.org/InStock",
//           itemCondition: "https://schema.org/NewCondition",
//           seller: {
//             "@type": "Organization",
//             "@id": ORGANIZATION_ID,
//             name: "Parish Audio",
//             url: "https://parishaudio.com",
//           },
//           hasMerchantReturnPolicy: buildReturnPolicyReference(),
//           shippingDetails: buildInstantDownloadShippingDetails("USD"),
//         },
//         aggregateRating:
//           visibleReviews.length > 0
//             ? {
//                 "@type": "AggregateRating",
//                 ratingValue: Number(averageRating || productData.starRating || 0),
//                 reviewCount: Number(
//                   productData.ratingCount || visibleReviews.length
//                 ),
//                 bestRating: 5,
//                 worstRating: 1,
//               }
//             : undefined,
//         review:
//           visibleReviews.length > 0
//             ? visibleReviews.slice(0, 10).map((review, index) => ({
//                 "@type": "Review",
//                 "@id": `${productUrl}#review-${review._id || index}`,
//                 name: review.title?.trim() || undefined,
//                 author: {
//                   "@type": "Person",
//                   name: review.userName || "Anonymous",
//                 },
//                 datePublished: review.createdAt,
//                 dateModified: review.updatedAt || review.createdAt,
//                 reviewBody: review.comment || undefined,
//                 reviewRating: {
//                   "@type": "Rating",
//                   ratingValue: Number(review.starRating),
//                   bestRating: 5,
//                   worstRating: 1,
//                 },
//                 itemReviewed: {
//                   "@id": productId,
//                 },
//               }))
//             : undefined,
//       },
//     ];

//     const cleanedSchemaData = JSON.parse(JSON.stringify(schemaData));

//     const script = document.createElement("script");
//     script.type = "application/ld+json";
//     script.text = JSON.stringify(cleanedSchemaData);
//     document.head.appendChild(script);

//     return () => {
//       document.head.removeChild(script);
//     };
//   }, [productData, reviews, averageRating]);

//   return null;
// };

// export default ProductReviewSchemaMarkup;

// import React, { useEffect } from "react";

// const ProductReviewSchemaMarkup = ({ productData, reviews, averageRating }) => {
//   useEffect(() => {
//     if (!productData) return;

//     const productUrl = `https://parishaudio.com/products/${productData.productURI}`;
//     const reviewPageUrl = `https://parishaudio.com/reviews/${productData.productURI}`;

//     const imageUrls = [
//       productData.googleMarketplaceImage
//         ? `https://parishaudio.com${productData.googleMarketplaceImage}`
//         : null,
//       ...(productData.images || [])
//         .filter((img) => img && img.URI)
//         .map((img) => `https://parishaudio.com${img.URI}`),
//     ].filter(Boolean);

//     const uniqueImageUrls = [...new Set(imageUrls)];

//     const productId = `${productUrl}#product`;
//     const offerId = `${productUrl}#offer`;
//     const reviewPageId = `${reviewPageUrl}#webpage`;

//     const visibleReviews = (reviews || []).filter((review) => review && review.visible !== false);

//     const schemaData = [
//       {
//         "@context": "https://schema.org",
//         "@type": "WebPage",
//         "@id": reviewPageId,
//         url: reviewPageUrl,
//         name: `${productData.name} Reviews | Parish Audio`,
//         description: `Read reviews for ${productData.name} by Parish Audio.`,
//       },
//       {
//         "@context": "https://schema.org",
//         "@type": "Product",
//         "@id": productId,
//         name: productData.name,
//         description:
//           productData.longDescription ||
//           productData.shortDescription ||
//           productData.cardSummary ||
//           undefined,
//         sku: productData.SKU || undefined,
//         url: productUrl,
//         image: uniqueImageUrls.length > 0 ? uniqueImageUrls : undefined,
//         brand: {
//           "@type": "Brand",
//           name: "Parish Audio",
//         },
//         manufacturer: {
//           "@type": "Organization",
//           name: "Parish Audio",
//           url: "https://parishaudio.com",
//         },
//         mainEntityOfPage: {
//           "@id": reviewPageId,
//         },
//         offers: {
//           "@type": "Offer",
//           "@id": offerId,
//           url: productUrl,
//           price: Number(productData.price || 0).toFixed(2),
//           priceCurrency: "USD",
//           availability: "https://schema.org/InStock",
//           itemCondition: "https://schema.org/NewCondition",
//           seller: {
//             "@type": "Organization",
//             name: "Parish Audio",
//             url: "https://parishaudio.com",
//           },
//         },
//         aggregateRating:
//           visibleReviews.length > 0
//             ? {
//                 "@type": "AggregateRating",
//                 ratingValue: Number(
//                   averageRating || productData.starRating || 0
//                 ),
//                 reviewCount: Number(
//                   productData.ratingCount || visibleReviews.length
//                 ),
//                 bestRating: 5,
//                 worstRating: 1,
//               }
//             : undefined,
//         review:
//           visibleReviews.length > 0
//             ? visibleReviews.slice(0, 10).map((review, index) => ({
//                 "@type": "Review",
//                 "@id": `${reviewPageUrl}#review-${review._id || index}`,
//                 name: review.title?.trim() || undefined,
//                 author: {
//                   "@type": "Person",
//                   name: review.userName || "Anonymous",
//                 },
//                 datePublished: review.createdAt,
//                 dateModified: review.updatedAt || review.createdAt,
//                 reviewBody: review.comment || undefined,
//                 reviewRating: {
//                   "@type": "Rating",
//                   ratingValue: Number(review.starRating),
//                   bestRating: 5,
//                   worstRating: 1,
//                 },
//                 itemReviewed: {
//                   "@id": productId,
//                 },
//               }))
//             : undefined,
//       },
//     ];

//     const cleanedSchemaData = JSON.parse(JSON.stringify(schemaData));

//     const script = document.createElement("script");
//     script.type = "application/ld+json";
//     script.text = JSON.stringify(cleanedSchemaData);
//     document.head.appendChild(script);

//     return () => {
//       document.head.removeChild(script);
//     };
//   }, [productData, reviews, averageRating]);

//   return null;
// };

// export default ProductReviewSchemaMarkup;

// import React, { useEffect } from "react";

// const ProductReviewSchemaMarkup = ({ productData, reviews, averageRating }) => {
//   useEffect(() => {
//     if (!productData) return;

//     const productUrl = `https://parishaudio.com/products/${productData.productURI}`;
//     const reviewPageUrl = `https://parishaudio.com/reviews/${productData.productURI}`;

//     const imageUrls = [
//       productData.googleMarketplaceImage
//         ? `https://parishaudio.com${productData.googleMarketplaceImage}`
//         : null,
//       ...(productData.images || [])
//         .filter((img) => img && img.URI)
//         .map((img) => `https://parishaudio.com${img.URI}`),
//     ].filter(Boolean);

//     const uniqueImageUrls = [...new Set(imageUrls)];

//     const productId = `${productUrl}#product`;
//     const offerId = `${productUrl}#offer`;
//     const reviewPageId = `${reviewPageUrl}#webpage`;

//     const schemaData = [
//       {
//         "@context": "https://schema.org",
//         "@type": "WebPage",
//         "@id": reviewPageId,
//         url: reviewPageUrl,
//         name: `${productData.name} Reviews | Parish Audio`,
//         description: `Read reviews for ${productData.name} by Parish Audio.`,
//       },
//       {
//         "@context": "https://schema.org",
//         "@type": "Product",
//         "@id": productId,
//         name: productData.name,
//         description:
//           productData.longDescription ||
//           productData.shortDescription ||
//           productData.cardSummary ||
//           undefined,
//         sku: productData.SKU || undefined,
//         url: productUrl,
//         image: uniqueImageUrls.length > 0 ? uniqueImageUrls : undefined,
//         brand: {
//           "@type": "Brand",
//           name: "Parish Audio",
//         },
//         manufacturer: {
//           "@type": "Organization",
//           name: "Parish Audio",
//           url: "https://parishaudio.com",
//         },
//         mainEntityOfPage: {
//           "@id": reviewPageId,
//         },
//         offers: {
//           "@type": "Offer",
//           "@id": offerId,
//           url: productUrl,
//           price: Number(productData.price || 0).toFixed(2),
//           priceCurrency: "USD",
//           availability: "https://schema.org/InStock",
//           itemCondition: "https://schema.org/NewCondition",
//           seller: {
//             "@type": "Organization",
//             name: "Parish Audio",
//             url: "https://parishaudio.com",
//           },
//         },
//         aggregateRating:
//           Number(productData.ratingCount) > 0
//             ? {
//                 "@type": "AggregateRating",
//                 ratingValue: Number(averageRating || productData.starRating || 0),
//                 reviewCount: Number(productData.ratingCount),
//                 bestRating: 5,
//                 worstRating: 1,
//               }
//             : undefined,
//         review:
//           reviews && reviews.length > 0
//             ? reviews.slice(0, 10).map((review, index) => ({
//                 "@type": "Review",
//                 "@id": `${reviewPageUrl}#review-${review._id || index}`,
//                 author: {
//                   "@type": "Person",
//                   name: review.userName || "Anonymous",
//                 },
//                 datePublished: review.createdAt,
//                 reviewBody: review.comment,
//                 reviewRating: {
//                   "@type": "Rating",
//                   ratingValue: Number(review.starRating),
//                   bestRating: 5,
//                   worstRating: 1,
//                 },
//                 itemReviewed: {
//                   "@id": productId,
//                 },
//               }))
//             : undefined,
//       },
//     ];

//     const cleanedSchemaData = JSON.parse(JSON.stringify(schemaData));

//     const script = document.createElement("script");
//     script.type = "application/ld+json";
//     script.text = JSON.stringify(cleanedSchemaData);
//     document.head.appendChild(script);

//     return () => {
//       document.head.removeChild(script);
//     };
//   }, [productData, reviews, averageRating]);

//   return null;
// };

// export default ProductReviewSchemaMarkup;

// import React, { useEffect } from "react";

// const ProductReviewSchemaMarkup = ({ productData, reviews, averageRating }) => {
//   useEffect(() => {
//     if (!productData) return;

//     const productUrl = `https://parishaudio.com/products/${productData.productURI}`;
//     const reviewPageUrl = `https://parishaudio.com/reviews/${productData.productURI}`;
//     const imageUrl = productData.images?.[0]?.URI
//       ? `https://parishaudio.com${productData.images[0].URI}`
//       : undefined;

//     const schemaData = {
//       "@context": "https://schema.org",
//       "@type": "SoftwareApplication",
//       name: productData.name,
//       applicationCategory: "MultimediaApplication",
//       operatingSystem: "Windows, macOS",
//       description: productData.shortDescription,
//       sku: productData.SKU,
//       url: productUrl,
//       publisher: {
//         "@type": "Organization",
//         name: "Parish Audio",
//         url: "https://parishaudio.com"
//       },
//       brand: {
//         "@type": "Brand",
//         name: "Parish Audio"
//       },
//       image: imageUrl,
//       offers: {
//         "@type": "Offer",
//         price: Number(productData.price || 0).toFixed(2),
//         priceCurrency: "USD",
//         availability: "https://schema.org/InStock",
//         url: productUrl
//       },
//       aggregateRating:
//         Number(productData.ratingCount) > 0
//           ? {
//               "@type": "AggregateRating",
//               ratingValue: String(averageRating || productData.starRating || 0),
//               reviewCount: String(productData.ratingCount)
//             }
//           : undefined,
//       review:
//         reviews && reviews.length > 0
//           ? reviews.slice(0, 10).map((review) => ({
//               "@type": "Review",
//               author: {
//                 "@type": "Person",
//                 name: review.userName || "Anonymous"
//               },
//               datePublished: review.createdAt,
//               reviewBody: review.comment,
//               reviewRating: {
//                 "@type": "Rating",
//                 ratingValue: String(review.starRating),
//                 bestRating: "5",
//                 worstRating: "1"
//               }
//             }))
//           : undefined,
//       mainEntityOfPage: reviewPageUrl
//     };

//     const cleanedSchemaData = JSON.parse(JSON.stringify(schemaData));

//     const script = document.createElement("script");
//     script.type = "application/ld+json";
//     script.innerHTML = JSON.stringify(cleanedSchemaData);
//     document.head.appendChild(script);

//     return () => {
//       document.head.removeChild(script);
//     };
//   }, [productData, reviews, averageRating]);

//   return null;
// };

// export default ProductReviewSchemaMarkup;